import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-538b2825"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fullscreen-modal__footer" }
const _hoisted_2 = { class: "container fullscreen-modal__footer-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-arrow-down icon-rotate-90 fullscreen-modal__go-back-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "fullscreen-modal__footer--right" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "fullscreen-modal__total"
}
const _hoisted_8 = {
  key: 2,
  class: "fullscreen-modal__total"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-check",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.editMode)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-no-styling fullscreen-modal__go-back",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.translate('shop.ticket.configuration.go-back')), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4)),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.stepViews[_ctx.step] === 'persons')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (!_ctx.isMobile)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getFilteredTicketCounter(), (item) => {
                    return (_openBlock(), _createElementBlock("span", null, _toDisplayString(_ctx.ticketCounter[item.id]) + " " + _toDisplayString(item.name) + ", ", 1))
                  }), 256))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.translate('shop.ticket.configuration.total')) + " ", 1),
              (_ctx.totalValue)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "CHF " + _toDisplayString(_ctx.totalValue), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, "CHF " + _toDisplayString(_ctx.total().toFixed(2)), 1))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass(["btn fullscreen-modal__submit", {'btn-primary': _ctx.stepViews[_ctx.step] === 'persons', 'btn-secondary': _ctx.stepViews[_ctx.step] !== 'persons'}]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeStep(_ctx.step+1))),
          disabled: !_ctx.validation[_ctx.currentStepName]
        }, [
          _hoisted_10,
          (_ctx.stepViews[_ctx.step] === 'persons' && !_ctx.editMode)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.translate('shop.ticket.configuration.add-to-cart')), 1))
            : (_ctx.stepViews[_ctx.step] === 'persons' && _ctx.editMode)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.translate('shop.ticket.configuration.update-cart')), 1))
              : (_ctx.stepViews[_ctx.step] !== 'persons')
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.translate('shop.ticket.configuration.next-step')), 1))
                : _createCommentVNode("", true)
        ], 10, _hoisted_9)
      ])
    ])
  ]))
}